import { AsqAirport } from '../../core/entities/asqAccess';

export function alphaAirportComparer(a: AsqAirport, b: AsqAirport): number {
  return a.code.localeCompare(b.code);
}
